import { Button } from './Button';
import { cx } from './classNames';
import { Icon } from './Icon';

/**
 * Fehlerzustand eines Bereichs (REQ-25 §3). Die technische Meldung wird nicht verschluckt,
 * sondern steht aufklappbar darunter — damit sie in eine Störungsmeldung kopiert werden kann.
 */
export interface ErrorStateProps {
  /** Standard „Das hat nicht geklappt". */
  title?: string;
  message: string;
  /** Technische Einzelheit, aufklappbar unter „Details". */
  detail?: string;
  /** Zeigt die Schaltfläche „Erneut versuchen". */
  onRetry?: () => void;
  size?: 'sm' | 'md';
}

export function ErrorState(props: ErrorStateProps) {
  const size = props.size ?? 'md';

  return (
    <div className={cx('iwm-state', `iwm-state--${size}`, 'iwm-state--error')} role="alert">
      <span className="iwm-state-icon">
        <Icon iconClass="fa-solid fa-circle-exclamation" />
      </span>
      <p className="iwm-state-title">{props.title ?? 'Das hat nicht geklappt'}</p>
      <p className="iwm-state-description">{props.message}</p>
      {props.detail === undefined || props.detail === '' ? null : (
        <details className="iwm-state-detail">
          <summary>Details</summary>
          <pre>{props.detail}</pre>
        </details>
      )}
      {props.onRetry === undefined ? null : (
        <div className="iwm-state-action">
          <Button
            content="Erneut versuchen"
            iconClass="fa-solid fa-arrows-rotate"
            onClick={props.onRetry}
          />
        </div>
      )}
    </div>
  );
}

export default ErrorState;
